var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 59,
    viewBox: "0 0 39 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5639 25.8944C12.5157 23.9606 9.92749 21.9611 9.92749 18.8472C9.92749 15.2744 13.5084 12.7833 19.5002 12.7833C25.8111 12.7833 28.1511 15.5694 28.3639 19.6667H36.1993C35.9511 14.0289 32.2284 8.85 24.8184 7.17833V0H14.182V7.08C7.30386 8.45667 1.77295 12.5867 1.77295 18.9128C1.77295 26.4844 8.54477 30.2539 18.4366 32.45C27.3002 34.4167 29.073 37.3011 29.073 40.3494C29.073 42.6111 27.3357 46.2167 19.5002 46.2167C12.1966 46.2167 9.32477 43.2011 8.93477 39.3333H1.13477C1.56022 46.5117 7.37477 50.5433 14.182 51.8872V59H24.8184V51.9528C31.732 50.74 37.2275 47.0361 37.2275 40.3167C37.2275 31.0078 28.612 27.8283 20.5639 25.8944Z",
    fill: "#00908E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.019a5707f2adabdda9c73f67a6c6e171.svg";
export { ForwardRef as ReactComponent };